var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkBlack = function SvgLinkBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17042",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17042",
    transform: "translate(-812.863 -3525.863)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_2",
    "data-name": "\\u6955\\u5186\\u5F62 2",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(812.863 3525.863)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16853",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16853",
    transform: "translate(819.758 3531.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16850",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16850",
    transform: "translate(3.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16849",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16166",
    "data-name": "\\u30D1\\u30B9 16166",
    d: "M192.491,0h-3.882a.485.485,0,1,0,0,.971h2.711l-4.995,4.995a.485.485,0,1,0,.686.686l4.995-4.995V4.367a.485.485,0,1,0,.971,0V.485A.485.485,0,0,0,192.491,0Z",
    transform: "translate(-186.182)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16852",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16852",
    transform: "translate(0 1.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16851",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16167",
    "data-name": "\\u30D1\\u30B9 16167",
    d: "M8.25,96a.485.485,0,0,0-.485.485v4.367H.971V94.062H5.338a.485.485,0,1,0,0-.971H.485A.485.485,0,0,0,0,93.576v7.764a.485.485,0,0,0,.485.485H8.25a.485.485,0,0,0,.485-.485V96.488A.485.485,0,0,0,8.25,96Z",
    transform: "translate(0 -93.091)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))))));
};
export default SvgLinkBlack;